// extracted by mini-css-extract-plugin
export default {"tableContainer":"CasesTable_tableContainer__9j5k7"};